<template>
  <div>
    <SGPRowComponent>
      <div class="p-4">
        <h4> Digite a número da OS</h4>
        <form @submit.prevent="submit()">
          <SGPFormInputComponent name="numeroOs" type="text" placeholder="Número OS" v-model="formulario.numeroOs" />
          <br>
          <SGPFormBotaoComponent type="submit" color="primary" block rounded middle >
          <span>Consultar</span>
        </SGPFormBotaoComponent>
        </form>
  
        <!-- Display the resposta -->
        <div class="sapweb-geral" v-if="resposta">
          <div class="row">
            <div class="col-md-5">
                <strong>Fase</strong><br>
                <label>{{ resposta.dados_empresa_parceira.fase }}</label>
            </div>
            <div class="col-md-4">
                <strong>Empreiteira</strong><br>
                <label>{{ resposta.dados_empresa_parceira.empreiteira }}</label>
            </div>
            <div class="col-md-3">
                <strong>Status</strong><br>
                <label>{{ resposta.status_wf1 }}</label>
            </div>
          </div>
  
          <div class="tabela-wf1-dados">
            <p class="titulo">Observações</p>
            <table>
              <thead>
              <tr>
                <th>USUÁRIO</th>
                <th>DATA</th>
                <th>OBSERVAÇÃO</th>
              </tr>
              </thead>
              <tbody v-if="resposta.observacao.length > 0">
              <tr v-for="(item, i) in resposta.observacao" :key="i">
                <td>{{ item.usuario }}</td>
                <td>{{ item.data }}</td>
                <td v-html="item.observacao"></td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="3" style="text-align: center; font-weight: bold;">
                  Nenhuma observação cadastrada
                </td>
              </tr>
              </tbody>
            </table>
          </div>
  
          <div class="lista-wf1-dados">
            <p class="titulo">Histórico</p>
  
            <div v-if="resposta.historico.length > 0">
              <ul v-for="(item, i) in resposta.historico" :key="i">
                <li><span class="description">FASE ATUAL</span>: {{ item.fase_atual }}</li>
                <li><span class="description">DATA INÍCIO</span>: {{ item.data_inicio }}</li>
                <li><span class="description">USER INCLUSÃO</span>: {{ item.user_inclusao }}</li>
                <li><span class="description">DATA FIM</span>: {{ item.data_fim }}</li>
                <li><span class="description">USER FECHAMENTO</span>: {{ item.user_fechamento }}</li>
                <li><span class="description">HISTÓRICO</span>: {{ item.historico }}</li>
                <li><span class="description">MOTIVO PENDÊNCIA</span>: {{ item.motivo_pendencia }}</li>
                <li><span class="description">VALIDADO</span>: {{ item.validado }}</li>
                <li><span class="description">MOTIVO RECUSA</span>: {{ item.motivo_recusa }}</li>
                <li><span class="description">USER VALIDAÇÃO</span>: {{ item.user_validacao }}</li>
                <li><span class="description">DATA VALIDAÇÃO</span>: {{ item.data_Validacao }}</li>
              </ul>
            </div>
            <div v-else style="text-align: center; font-weight: bold">
              Nenhum histórico registrado
            </div>
          </div>
        </div>
      </div>
    </SGPRowComponent>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
name: 'ConsultaWf1Component',
components: {
  
},
props:{
  value: {
    type: Boolean,
    required: true,
    default: false
  },
},
data () {
  return {    
      submitForm: false,
      formulario: {
          numeroOs: ''
      },
      resposta: null,
    }
  },

mounted() {
  if (this.value) {
    this.formulario.numeroOs = this.value.wf1;
  }
},

methods: {
  ...mapActions('automacao', [
    'listarWF1'
  ]),
  async submit() {
    this.submitForm = true;
    this.resposta = null;
    const payload = {
      numeroOs: parseInt(this.formulario.numeroOs)
    };
    
    try {
      let response = await this.listarWF1(payload);
      if (response && response.data.data) {
        this.resposta = response.data.data;
      } else {
        console.error('Erro ao consultar OS:', response);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
    }
  },
}
}

</script>
<style scoped lang="scss">
.sapweb-geral {
  padding-top: 15px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.sapweb-dados {
  //float: left;
  display: block;
  margin-bottom: 10px;
  width: calc(50% - 10px);
}



.lista-wf1-dados {
  display: block;
  width: 100%;
  margin-top: 15px;
  background: white;

  .titulo {
    width: 100%;
    padding: 5px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    background: #dddddd;
    margin-bottom: 0;
  }

  ul{
    width: 100%;
    padding-top: 15px;
    border-top: 1px solid #ddd;
    li {
      .description {
        font-weight: bold;
      }
    }
  }
}

.tabela-wf1-dados {
  display: block;
  width: 100%;
  margin-top: 15px;
  background: white;

  .titulo {
    width: 100%;
    padding: 5px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    background: #dddddd;
    margin-bottom: 0;
  }
  table {
    border: 1px solid;
    width: 100%;

    tr {
      border: 1px solid;
      th{
        border: 1px solid;
        text-align: center;
        padding: 5px 10px;
      }
      td {
        border: 1px solid;
        padding: 5px;
      }
    }
  }
}
</style>